// InfoCard.js
import React from "react";
import { createRoot } from "react-dom/client";

export const createInfoCard = ({ title, subtitle, onModeSelect}) => {
  const el = document.createElement("div");
  const root = createRoot(el);

  root.render(
    <div className="w-40  p-4 relative">
      {/* Close button */}
      

      <div className="flex justify-center">
        <img
          src="image.png"
          alt="Place"
          className="w-24 h-24 rounded-full object-cover border"
        />
      </div>

      <h2 className="text-center text-gray-700 font-medium mt-3">
        {title} <br /> {subtitle}
      </h2>

      {/* 🚶 + 🚗 buttons */}
      <div className="flex justify-center gap-8 mt-4">
        <img
          src="/direction-walk.png"
          alt="Walk"
          className="cursor-pointer w-8 h-8"
          onClick={() => onModeSelect && onModeSelect("walking")}
        />
        <img
          src="/direction-car.png"
          alt="Car"
          className="cursor-pointer w-8 h-8"
          onClick={() => onModeSelect && onModeSelect("driving")}
        />
      </div>

      <div className="absolute left-1/2 -bottom-3 -translate-x-1/2 w-0 h-0 
        border-l-[12px] border-r-[12px] border-t-[12px] 
        border-l-transparent border-r-transparent border-t-white"></div>
    </div>
  );

  return el;
};
